import requestUtils from 'api/requestUtils'

interface Response {
  result: {
    isSocieteRecentlyGranted: boolean
  }
}

async function requestGetEmployeeSociete(params: {
  businessId: string
}) {
  const { businessId } = params
  const response = await requestUtils.get<Response>(
    `/api/business-traveller/businesses/${businessId}/employees/employee-societe`,
    { credentials: 'include' },
  )
  return response.result
}

export default requestGetEmployeeSociete
